import * as localforage from "localforage";
import axios from "axios";
import { successHandling } from "../helpers/successHandling";
import { currentDateInUTC } from "@/helpers/datetimeHandlers";

export const setHeartBeatAPI = async (
  device_ids,
  sending_time,
  t,
  successfulText
) => {
  let formData = new FormData();
  formData.append("execute_type", "set_heartbeat_time");
  formData.append("device_ids[]", device_ids);
  formData.append("sending_time", sending_time);
  let res = await axios({
    url: `/api/v2/command/setting/heartbeat-send`,
    method: "POST",
    data: formData
  });
  successHandling(t, successfulText);
  return res.data;
};

export const screenshotsSendApi = async device_id => {
  const company_id = await localforage.getItem("companyId");
  let formData = new FormData();
  formData.append("execute_datetime", currentDateInUTC());
  formData.append("device_ids[]", device_id);
  formData.append("company_id", company_id);
  formData.append("execute_type", "screenshot");
  formData.append("type", "company");
  let res = await axios({
    url: `/api/v2/command/screenshot-send`,
    method: "POST",
    data: formData
  });
  return res.data;
};

export const getScreenshotsApi = async task_id => {
  const user = await localforage.getItem("user");
  let res = await axios({
    url: `/api/v2/device/screenshots`,
    method: "GET",
    params: {
      user_id: user.id,
      task_id
    }
  });
  return res.data;
};

export const screenshotDownloadUrlAPI = async (device_id, screenshot_id) => {
  let formData = new FormData();

  formData.append("device_id", device_id);
  formData.append("screenshot_id", screenshot_id);
  let res = await axios({
    url: `/api/v2/drive/file/download-screenshot`,
    method: "POST",
    data: formData
  });
  return res.data;
};

export const deleteAppApi = async (device_ids, name, t, successfulText) => {
  let res = await axios({
    url: `/api/v2/command/delete-software-send`,
    method: "POST",
    data: {
      device_ids,
      name,
      execute_type: "delete_software"
    }
  });
  successHandling(t, successfulText);
  return res.data;
};

export const getOperationApi = async device_id => {
  let res = await axios({
    url: `/api/v2/device/realtime-monitor/operation`,
    method: "GET",
    params: {
      device_id
    }
  });
  return res.data;
};

export const getDeviceTwinsApi = async device_id => {
  let res = await axios({
    url: `/api/v2/device/twins`,
    method: "GET",
    params: {
      device_id
    }
  });
  return res.data;
};
